import React from 'react';
import { REVIEW_STATUS, REVIEW_STATUS_TITLES } from '../../constants';
import { Select } from './StatusFilter.styles';

export const StatusFilter = ({ status, onChange }) => (
  <Select
    value={status}
    onChange={e => onChange(e.target.value)}
    aria-label='Show stones'
  >
    {Object.values(REVIEW_STATUS).map(value => (
      <option key={value} value={value}>
        {REVIEW_STATUS_TITLES[value]}
      </option>
    ))}
  </Select>
);
